import { PartnerPending } from "../entities/partnerPending";
import { PartnerSocketRepository } from "../repositories/PartnerSocketRepository";

export class GetNotificationsPartner {
	constructor(private repository: PartnerSocketRepository) {}

	execute(callback: (data: PartnerPending) => void): void {
		return this.repository.getNotificationsPartner(callback);
	}
}
